export class ListData {
    canAdd!: boolean;
    pageIndex!: number;
    totalCount!: number;
    pageSize!: number;
    pageData!: {
      canDelete: boolean
      canEdit: boolean
      created: string
      id: string
      title_EN: string
      title_AR: string
      name: string
      numberOfUse: number
      staffMemberCount: number
      menuItemCount: number
      responseChefName: string
      responseCheficon: string
    }[];
  }
  
  export class Record {
    id!: string
    title_EN!: string
    title_AR!: string
    restaurantsId!: number
    hasKDS!: boolean
    printDeviceType!: string
    devicePath!: string
    devicePort!: number
  }
  
  export class ListFilter {
    pageSize!: number;
    pageNumber!: number;
    sortItems!: sortList;
    searchText!: string;
    createdFrom!: Date;
    createdTo!: Date;
    restaurantId!: number;
  }
  
  export enum sortList {
    Name = 0,
    NewestCreate = 1,
    OldestCreate = 2,
    HighestUse = 4,
    LowestUse = 3,
    Highest_Amount = 5,
    Lowest_Amount = 6
  }
  
  export enum printType {
    Wifi = 'Wifi',
    Bluetooth = 'BlueTooth'
  }